import React, { useEffect } from "react";
export interface User {
  canComment: true;
  canWrite: true;
  connectionId: string;
  id: string | undefined;
  presence?: {
    cursor: {
      x: number;
      y: number;
    };
    id: string;
    info?: {
      color: string;
      name: string;
    };
  };
}

interface Store {
  status: string;
  connectionStatus: string;
  others: User[];
  user: User | null;
}

const Users = ({ store }: { store: Store }) => {
  // const currentUser = store.user;

  // const displayedUsers = store.others.slice(0, 2);
  // const additionalUsersCount = displayedUsers.length - 2;

  return (
    <ul className="flex flex-col items-center justify-center">
      {/* {currentUser && <Avatar picture={currentUser.presence?.info?.color} name={currentUser.presence?.info?.name} />}
      {displayedUsers.map((user: User) => {
        const name = user.presence?.info?.name;
        const color = user.presence?.info?.color;
        return (
          <>
            <Avatar key={user.connectionId} picture={color} name={name} />
          </>
        );
      })}

      {additionalUsersCount > 0 && (
        <li
          style={{ border: "2px solid white" }}
          className="w-10 h-10 -mt-2 rounded-full flex items-center justify-center text-white text-[18px] bg-gray-500"
          title={`${additionalUsersCount} more users`}
        >
          +{additionalUsersCount}
        </li>
      )} */}
    </ul>
  );
};

export default Users;

interface AvatarProps {
  picture: string | undefined;
  name: string | undefined;
}

export function Avatar({ picture, name }: AvatarProps) {
  return (
    <div style={{ marginTop: "-10px" }} data-tooltip={name}>
      <div
        className="flex items-center justify-center w-10 h-10 rounded-full text-white text-[18px]"
        style={{ backgroundColor: picture, border: "2px solid white" }}
        title={name}
      >
        {name?.charAt(0).toUpperCase()}
      </div>
    </div>
  );
}

export function Cursor({ x, y, name, color }: any) {
  return (
    <div
      style={{
        position: "absolute",
        transform: `translate(${x}px, ${y}px)`,
        zIndex: 100,
        display: "flex",
        alignItems: "center",
      }}
    >
      <svg
        height="20px"
        width="20px"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 401.292 401.292"
        fill="black"
        stroke="black"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <g>
            <polygon style={{ fill: color }} points="46.943,401.292 166.905,257.261 46.943,0 "></polygon>
            <polygon style={{ fill: color }} points="46.943,0 166.905,257.261 354.349,257.945 "></polygon>
          </g>
        </g>
      </svg>
      <p
        style={{ backgroundColor: color }}
        className={"ml-[-2px] mb-[-35px] text-white px-[4px] py-[0px] rounded-sm border"}
      >
        {name}
      </p>
    </div>
  );
}
